import type { AnimeItem, Category, Episode, FAQItem } from '@/pages/home/types';

export const siteConfig = {
  name: '樱花动漫网',
  tagline: '免费高清动漫大全',
  description: '樱花动漫网不仅提供动漫，还支持电视剧和电影在线观看，免费高清动漫大全让您一站式享受多种娱乐内容，无需付费即可浏览丰富资源。',
  keywords: '樱花动漫网,电视剧电影动漫,免费高清动漫,动漫大全',
  url: 'https://nabyxac.cn',
  logo: '🌸 樱花动漫',
};

export const categories: Category[] = [
  { id: 'recent', name: '热门推荐', slug: 'recent', icon: 'ri-fire-line', description: '当下最热门的动漫作品推荐，每周更新热门榜单' },
  { id: 'japanese', name: '日本动漫', slug: 'japanese', icon: 'ri-sun-line', description: '来自日本的经典与最新动漫作品合集' },
  { id: 'chinese', name: '国产动漫', slug: 'chinese', icon: 'ri-china-railway-line', description: '国产精品动漫，支持国漫崛起' },
  { id: 'movie', name: '动画电影', slug: 'movie', icon: 'ri-film-line', description: '精选动画电影大片，影院级别视觉体验' },
  { id: 'tv', name: '电视剧', slug: 'tv', icon: 'ri-tv-line', description: '热门电视剧在线观看，追剧必备' },
  { id: 'movie-live', name: '电影', slug: 'movie-live', icon: 'ri-movie-line', description: '高清电影资源，各类大片一网打尽' },
  { id: 'finished', name: '已完结', slug: 'finished', icon: 'ri-check-double-line', description: '已完结动漫作品，一口气看个够' },
];

export const animeList: AnimeItem[] = [
  {
    id: 1,
    title: '进击的巨人 最终季',
    slug: 'attack-on-titan-final',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20titan%20with%20dramatic%20lighting%20and%20dark%20atmosphere%2C%20epic%20fantasy%20scene%20with%20detailed%20character%20design%2C%20cinematic%20composition%2C%20professional%20anime%20art%20style%20with%20rich%20colors%20and%20dynamic%20posing%20on%20clean%20background&width=600&height=840&seq=anime-cover-01&orientation=portrait',
    category: 'japanese',
    rating: 9.8,
    updateInfo: '更新至第87集',
    description: '在巨人的世界陷入混乱之际，艾伦·耶格尔做出了改变一切的选择。最终季迎来史诗级大结局，人类与巨人之间长达两千年的战争即将画上句点。',
    tags: ['热血', '战斗', '奇幻', '谏山创'],
    publishDate: '2024-03-15',
    episodes: [
      { title: '第87集：终末之夜', number: 87, url: '#' },
      { title: '第86集：回首', number: 86, url: '#' },
      { title: '第85集：叛徒', number: 85, url: '#' },
      { title: '第84集：地鸣', number: 84, url: '#' },
      { title: '第83集：终末之夜', number: 83, url: '#' },
    ],
  },
  {
    id: 2,
    title: '鬼灭之刃 锻刀村篇',
    slug: 'demon-slayer-swordsmith',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20demon%20slayer%20with%20katana%20sword%20amidst%20cherry%20blossoms%2C%20traditional%20Japanese%20aesthetic%20with%20vibrant%20red%20and%20pink%20tones%2C%20professional%20anime%20art%20style%2C%20clean%20minimal%20background%20with%20soft%20gradient&width=600&height=840&seq=anime-cover-02&orientation=portrait',
    category: 'japanese',
    rating: 9.6,
    updateInfo: '更新至第11集',
    description: '炭治郎一行人来到锻刀村，面对更加强大的上弦之鬼。全新的日轮刀与更加激烈的战斗即将展开，鬼杀队与十二鬼月的宿命对决进入白热化阶段。',
    tags: ['热血', '战斗', '和风', '奇幻'],
    publishDate: '2024-06-01',
    episodes: [
      { title: '第11集：相连的羁绊', number: 11, url: '#' },
      { title: '第10集：恋之呼吸', number: 10, url: '#' },
      { title: '第9集：迷雾之中', number: 9, url: '#' },
      { title: '第8集：上弦集结', number: 8, url: '#' },
      { title: '第7集：锻刀村', number: 7, url: '#' },
    ],
  },
  {
    id: 3,
    title: '葬送的芙莉莲',
    slug: 'frieren-beyond-journey',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20illustration%20of%20an%20elf%20mage%20girl%20with%20silver%20hair%20in%20a%20fantasy%20landscape%2C%20gentle%20and%20emotional%20atmosphere%2C%20soft%20pastel%20color%20palette%2C%20professional%20anime%20art%20style%20with%20dreamy%20lighting%20on%20clean%20background&width=600&height=840&seq=anime-cover-03&orientation=portrait',
    category: 'japanese',
    rating: 9.7,
    updateInfo: '更新至第28集',
    description: '打倒魔王之后，长生种的精灵魔法使芙莉莲踏上了了解人类的旅程。这是一段关于时间、记忆与情感的温馨奇幻故事，触碰每个观众内心最柔软的地方。',
    tags: ['治愈', '奇幻', '冒险', '情感'],
    publishDate: '2024-04-20',
    episodes: [
      { title: '第28集：再会之时', number: 28, url: '#' },
      { title: '第27集：一级魔法使考试', number: 27, url: '#' },
      { title: '第26集：回忆中的她', number: 26, url: '#' },
      { title: '第25集：北方的勇者', number: 25, url: '#' },
      { title: '第24集：灵魂的轨迹', number: 24, url: '#' },
    ],
  },
  {
    id: 4,
    title: '时光代理人 第二季',
    slug: 'link-click-season2',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20anime%20donghua%20style%20illustration%20of%20two%20young%20men%20in%20modern%20urban%20setting%2C%20time%20travel%20mystery%20theme%2C%20cool%20color%20tones%20with%20cyan%20and%20teal%20accents%2C%20professional%20animation%20art%20style%20on%20clean%20background&width=600&height=840&seq=anime-cover-04&orientation=portrait',
    category: 'chinese',
    rating: 9.5,
    updateInfo: '更新至第12集',
    description: '程小时和陆光继续经营时光照相馆，这一次他们面对更加复杂的委托和危险的时间线。国产动画的又一力作，悬疑与情感的双重盛宴。',
    tags: ['悬疑', '国产', '都市', '剧情'],
    publishDate: '2024-05-10',
    episodes: [
      { title: '第12集：真相之门', number: 12, url: '#' },
      { title: '第11集：最后的照片', number: 11, url: '#' },
      { title: '第10集：时间的代价', number: 10, url: '#' },
      { title: '第9集：完美犯罪', number: 9, url: '#' },
      { title: '第8集：镜中人', number: 8, url: '#' },
    ],
  },
  {
    id: 5,
    title: '咒术回战 第二季',
    slug: 'jujutsu-kaisen-s2',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20sorcerer%20with%20dark%20hair%20and%20intense%20expression%2C%20supernatural%20battle%20theme%20with%20cursed%20energy%20visual%20effects%2C%20bold%20red%20and%20black%20color%20scheme%2C%20professional%20anime%20art%20style%20on%20clean%20background&width=600&height=840&seq=anime-cover-05&orientation=portrait',
    category: 'japanese',
    rating: 9.4,
    updateInfo: '更新至第23集',
    description: '涩谷事变篇震撼来袭！五条悟被封印，咒术界陷入前所未有的危机。虎杖悠仁与伙伴们面对史上最强的敌人，一场关乎世界命运的决战拉开帷幕。',
    tags: ['热血', '战斗', '超自然', '校园'],
    publishDate: '2024-02-28',
    episodes: [
      { title: '第23集：涩谷事变·闭幕', number: 23, url: '#' },
      { title: '第22集：变身', number: 22, url: '#' },
      { title: '第21集：机械丸的逆袭', number: 21, url: '#' },
      { title: '第20集：五条悟VS咒灵', number: 20, url: '#' },
      { title: '第19集：涩谷事变·开幕', number: 19, url: '#' },
    ],
  },
  {
    id: 6,
    title: '铃芽之旅',
    slug: 'suzume-no-tojimari',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20movie%20illustration%20of%20a%20school%20girl%20standing%20before%20a%20mysterious%20door%20in%20ruins%2C%20beautiful%20sky%20and%20landscape%2C%20Makoto%20Shinkai%20style%20with%20vibrant%20blues%20and%20warm%20sunlight%2C%20cinematic%20composition%20on%20clean%20background&width=600&height=840&seq=anime-cover-06&orientation=portrait',
    category: 'movie',
    rating: 9.3,
    updateInfo: '高清完整版',
    description: '新海诚导演最新力作！少女铃芽在日本各地的废墟中关闭灾难之门。一段跨越日本的奇幻公路之旅，融合了灾难、成长与爱情元素的视觉盛宴。',
    tags: ['电影', '奇幻', '爱情', '公路'],
    publishDate: '2024-01-15',
    episodes: [
      { title: '铃芽之旅 高清完整版', number: 1, url: '#' },
    ],
  },
  {
    id: 7,
    title: '庆余年 第二季',
    slug: 'joy-of-life-s2',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20illustration%20of%20a%20scholar%20in%20traditional%20robes%20with%20palace%20background%2C%20ancient%20Chinese%20aesthetic%20with%20warm%20golden%20tones%2C%20professional%20costume%20drama%20art%20style%20on%20clean%20background&width=600&height=840&seq=anime-cover-07&orientation=portrait',
    category: 'tv',
    rating: 9.2,
    updateInfo: '更新至第36集',
    description: '范闲从北齐归来，京都风云再起。各方势力暗流涌动，皇权斗争的棋局愈发复杂。张若昀、陈道明等实力派演员联袂出演，年度必看古装大剧。',
    tags: ['古装', '权谋', '剧情', '国产'],
    publishDate: '2024-07-01',
    episodes: [
      { title: '第36集：棋局终盘', number: 36, url: '#' },
      { title: '第35集：暗流涌动', number: 35, url: '#' },
      { title: '第34集：帝王心术', number: 34, url: '#' },
      { title: '第33集：父与子', number: 33, url: '#' },
      { title: '第32集：京都风云', number: 32, url: '#' },
    ],
  },
  {
    id: 8,
    title: '流浪地球2',
    slug: 'wandering-earth-2',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20illustration%20of%20Earth%20with%20planetary%20engines%20in%20space%2C%20futuristic%20technology%20theme%20with%20blue%20energy%2C%20epic%20scale%20cinematic%20composition%2C%20professional%20movie%20poster%20art%20style%20on%20clean%20dark%20background&width=600&height=840&seq=anime-cover-08&orientation=portrait',
    category: 'movie-live',
    rating: 9.1,
    updateInfo: '高清完整版',
    description: '太阳危机即将来临，人类启动"移山计划"，建造万座行星发动机推动地球离开太阳系。中国科幻电影的里程碑之作，视觉效果震撼全球。',
    tags: ['科幻', '灾难', '国产', '电影'],
    publishDate: '2024-02-10',
    episodes: [
      { title: '流浪地球2 高清完整版', number: 1, url: '#' },
    ],
  },
  {
    id: 9,
    title: '我独自升级',
    slug: 'solo-leveling',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20hunter%20with%20dark%20aura%20and%20glowing%20eyes%2C%20dungeon%20fantasy%20theme%20with%20shadow%20army%2C%20purple%20and%20black%20color%20scheme%2C%20professional%20anime%20art%20style%20on%20clean%20background&width=600&height=840&seq=anime-cover-09&orientation=portrait',
    category: 'japanese',
    rating: 9.5,
    updateInfo: '更新至第12集',
    description: '最弱猎人成振宇在经历生死考验后获得"系统"的力量，从此开启了一段成为世界最强的不凡旅程。超人气韩漫改编，燃到飞起的战斗场面。',
    tags: ['热血', '奇幻', '战斗', '韩漫改编'],
    publishDate: '2024-03-01',
    episodes: [
      { title: '第12集：觉醒', number: 12, url: '#' },
      { title: '第11集：转职', number: 11, url: '#' },
      { title: '第10集：恶魔城', number: 10, url: '#' },
      { title: '第9集：影子军团', number: 9, url: '#' },
      { title: '第8集：S级猎人', number: 8, url: '#' },
    ],
  },
  {
    id: 10,
    title: '沧元图',
    slug: 'cang-yuan-tu',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20illustration%20of%20a%20martial%20artist%20with%20elemental%20powers%20in%20ancient%20Chinese%20fantasy%20world%2C%20ink%20wash%20painting%20style%20with%20dynamic%20action%2C%20traditional%20aesthetic%20with%20modern%20animation%20quality%20on%20clean%20background&width=600&height=840&seq=anime-cover-10&orientation=portrait',
    category: 'chinese',
    rating: 9.3,
    updateInfo: '更新至第52集',
    description: '少年孟川在妖魔横行的世界中修炼武道，为守护家园而战。国产动画的顶级制作水准，水墨画风与3D技术的完美融合，展现东方幻想的独特魅力。',
    tags: ['玄幻', '国产', '战斗', '热血'],
    publishDate: '2024-04-05',
    episodes: [
      { title: '第52集：巅峰之战', number: 52, url: '#' },
      { title: '第51集：元初山', number: 51, url: '#' },
      { title: '第50集：神魔之体', number: 50, url: '#' },
      { title: '第49集：觉醒', number: 49, url: '#' },
      { title: '第48集：决战前夕', number: 48, url: '#' },
    ],
  },
  {
    id: 11,
    title: '间谍过家家 第二季',
    slug: 'spy-x-family-s2',
    coverImage: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20family%20of%20three%20with%20comedy%20and%20spy%20theme%2C%20warm%20and%20playful%20atmosphere%2C%20pastel%20color%20palette%20with%20soft%20lighting%2C%20professional%20anime%20art%20style%20on%20clean%20background&width=600&height=840&seq=anime-cover-11&orientation=portrait',
    category: 'japanese',
    rating: 9.4,
    updateInfo: '更新至第25集',
    description: '间谍父亲、杀手母亲、读心术女儿——这个临时组建的家庭继续着他们笑料百出的日常。然而和平的表象之下，各方的秘密任务仍在继续。',
    tags: ['喜剧', '日常', '间谍', '治愈'],
    publishDate: '2024-01-20',
    episodes: [
      { title: '第25集：家人的羁绊', number: 25, url: '#' },
      { title: '第24集：游轮大作战', number: 24, url: '#' },
      { title: '第23集：狗狗的冒险', number: 23, url: '#' },
      { title: '第22集：约尔的秘密', number: 22, url: '#' },
      { title: '第21集：黄昏的新任务', number: 21, url: '#' },
    ],
  },
  {
    id: 12,
    title: '斗破苍穹 年番',
    slug: 'battle-through-heavens',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20donghua%20illustration%20of%20a%20young%20man%20with%20flame%20powers%20and%20fantasy%20martial%20arts%2C%20ancient%20Chinese%20palace%20in%20background%2C%20fire%20and%20ash%20color%20scheme%2C%20professional%203D%20animation%20art%20style%20on%20clean%20background&width=600&height=840&seq=anime-cover-12&orientation=portrait',
    category: 'chinese',
    rating: 9.0,
    updateInfo: '已完结 共208集',
    description: '天才少年萧炎从云端跌落谷底，在药老指导下一步步重回巅峰。经典网文改编的长篇动画，从加玛帝国到中州大陆，一段波澜壮阔的修炼之旅。',
    tags: ['玄幻', '国产', '战斗', '长篇'],
    publishDate: '2024-06-15',
    episodes: [
      { title: '第208集：斗帝之路·终章', number: 208, url: '#' },
      { title: '第207集：最终决战', number: 207, url: '#' },
      { title: '第206集：魂天帝', number: 206, url: '#' },
      { title: '第205集：古帝洞府', number: 205, url: '#' },
      { title: '第204集：最后的试炼', number: 204, url: '#' },
    ],
  },
];

export const featuredAnimeIds = [1, 2, 3, 4, 5, 6, 7, 8];

export const latestAnimeIds = [1, 2, 5, 9, 4, 11, 3, 10];

export const faqList: FAQItem[] = [
  {
    question: '樱花动漫网的资源都是免费的吗？',
    answer: '是的，樱花动漫网上的所有动漫、电视剧和电影资源均可免费在线观看。我们致力于为动漫爱好者提供高质量的免费内容，无需注册和付费即可畅享海量资源。',
  },
  {
    question: '网站上的视频画质怎么样？',
    answer: '我们提供高清画质（1080P）的视频资源，部分热门作品还支持4K超清画质。所有视频均经过精心转码优化，确保流畅的观看体验，同时兼顾画质与加载速度。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '当然可以！樱花动漫网完美适配手机、平板和电脑等各种设备。无论您使用iOS还是Android设备，都能获得流畅舒适的观影体验，随时随地追番看剧。',
  },
  {
    question: '网站的更新频率如何？',
    answer: '我们每天都会更新最新动漫和影视资源，热门连载作品会在日本/国内播出后第一时间同步更新。您可以收藏喜欢的作品，开启更新提醒，不错过任何精彩内容。',
  },
  {
    question: '如何搜索想看的动漫？',
    answer: '您可以使用页面顶部的搜索功能，输入作品名称或关键词即可快速找到。此外，我们还提供了详细的分类导航和热门推荐，帮助您发现更多优质作品。',
  },
  {
    question: '遇到无法播放的情况怎么办？',
    answer: '如果遇到播放问题，建议您先尝试刷新页面或切换播放线路。我们为每部作品准备了多个备用播放源。若问题持续存在，可以通过"关于我们"页面的联系方式向我们反馈，我们会尽快修复。',
  },
];

export const brandInfo = {
  introduction: '樱花动漫网成立于2020年，是国内领先的免费动漫在线观看平台。我们致力于为广大动漫爱好者提供海量、高清、正版的动漫、电视剧和电影资源。五年来，樱花动漫网凭借优质的内容和良好的用户体验，已积累了超过5000万忠实用户。',
  mission: '让每一个热爱动漫的人都能自由地享受精彩内容，是我们不变的初心。',
  features: [
    { title: '海量资源', description: '收录超过10000部动漫作品，涵盖日漫、国漫、美漫等多种类型' },
    { title: '高清画质', description: '支持1080P/4K超清播放，带来影院级观影体验' },
    { title: '极速更新', description: '热门番剧播出后2小时内同步更新中文字幕版' },
    { title: '多端适配', description: 'PC、手机、平板全平台支持，随时随地畅享动漫' },
  ],
  stats: [
    { value: '5000万+', label: '月活用户' },
    { value: '10000+', label: '收录作品' },
    { value: '99.9%', label: '服务可用率' },
    { value: '4.9/5', label: '用户评分' },
  ],
  testimonials: [
    { name: '动漫爱好者小陈', content: '樱花动漫网的画质真的绝了，而且更新特别快，每周追番就靠它了！界面也很清爽，没有烦人的广告弹窗。', rating: 5 },
    { name: '二次元少女小雨', content: '用了三年了，资源太全了！国产动漫和日本动漫都有，分类做得也很细致，找番特别方便。强烈推荐！', rating: 5 },
    { name: '追剧达人老王', content: '不只是动漫，电视剧和电影资源也很多。高清画质+流畅播放，体验比很多付费平台还好，真的是良心网站。', rating: 5 },
    { name: '学生党小李', content: '免费的还能这么高清，简直是学生党的福音！宿舍晚上和室友一起追番，成了我们的固定节目。', rating: 4 },
  ],
};

export type { AnimeItem, Category, Episode, FAQItem } from '@/pages/home/types';